(() => {
  const analytics = () => window.RECAnalytics;

  const cleanToken = (value, max = 64) => String(value || '')
    .toLowerCase()
    .replace(/[^a-z0-9_-]+/g, '_')
    .replace(/^_+|_+$/g, '')
    .slice(0, max);

  const destinationPath = (href) => {
    if (!href) return '';
    try {
      const url = new URL(href, window.location.origin);
      return url.origin === window.location.origin ? (url.pathname || '/') : 'external';
    } catch (_) {
      return '';
    }
  };

  const laneFromHref = (href) => {
    const path = destinationPath(href);
    if (!path || path === 'external') return '';
    const parts = path.split('/').filter(Boolean);
    return cleanToken(parts[parts.length - 1] || '', 48);
  };

  const record = (action, target, lane = '') => {
    const rec = analytics();
    if (!rec || typeof rec.engage !== 'function' || !rec.analyticsAllowed?.()) return;
    const link = target?.closest?.('a[href]');
    rec.engage({
      feature: 'homepage',
      action: cleanToken(action, 48),
      lane: cleanToken(lane, 48),
      destination: link?.href || ''
    });
  };

  const classify = (target) => {
    const section = target.closest?.('[id^="shopify-section-"]');
    const id = section?.id || '';

    if (id.endsWith('__background_video_wxdzVD')) return ['hero_cta', 'new_drops'];
    if (id.endsWith('__collections_list_manual_4UGYPE')) {
      const href = target.closest?.('a[href]')?.href || '';
      return ['shop_your_thing', laneFromHref(href)];
    }
    if (id.endsWith('__featured_collection_Jb98JF')) return ['fresh_off_press', 'new_drops'];
    if (id.endsWith('__featured_collection_rec_ready_to_ship')) return ['ready_to_ship', 'ready_to_ship'];
    if (id.endsWith('__featured_collection_rec_favorites')) return ['rec_favorites', 'favorites'];
    if (id.endsWith('__1732153070ba401880')) return ['reviews', 'judge_me'];
    if (id.endsWith('__hero_image_XrYb4R')) return ['after_dark', 'after_dark'];
    if (id.endsWith('__image_text_W6VCbx')) return ['dtf', 'dtf'];
    if (target.closest?.('.rec-custom-btn')) return ['custom_order', 'custom'];
    return null;
  };

  const boot = () => {
    if (!document.body?.classList.contains('template-index')) return;
    document.addEventListener('click', (event) => {
      const target = event.target.closest?.('a,button,[role="button"]');
      if (!target) return;
      const hit = classify(target);
      if (!hit) return;
      record(hit[0], target, hit[1]);
    }, true);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
